<script>
import { mapActions, mapState } from 'vuex';
import filters from '@enums/filters';
import filterBar from '@/js/components/filter-bar.vue';
import filterBarMixin from '@/js/pages/supplier/components/mixins/suppliers-filter-bar-mixin.vue';

export default {
    extends: filterBar,
    mixins: [filterBarMixin],
    emits: ['change-categories-filter'],

    computed: {
        ...mapState('variableFundingAgreements', ['variableFundingAgreements']),
    },

    methods: {
        ...mapActions(['resetSuppliersFilters']),
        ...mapActions('variableFundingAgreements', [
            'fetchVariableFundingAgreementsSuppliersAndProductByCategory',
            'resetVariableFundingAgreementsState',
            'setSelectedCategory',
        ]),
        ...mapActions('supplierCommitments', [
            'resetSupplierCommitmentsState',
            'clearSelectedSupplierCommitment',
        ]),

        async onFilterValueChange({ filterKey, event }) {
            if (filterKey === filters.categories) {
                // remove old supplier filter for updated category
                this.removeSupplierFilter();

                this.$emit('change-categories-filter');

                // fetch variableFundingAgreements, suppliers and products by category
                await this.setSelectedCategory({ categoryKey: event });

                return this.fetchVariableFundingAgreementsSuppliersAndProductByCategory(event);
            }
        },

        resetFilters({ filterId }) {
            // if category filter is not selected, we show empty list of
            // variable-funding-agreements and supplier-commitments
            this.resetVariableFundingAgreementsState();
            this.resetSupplierCommitmentsState();
            this.clearSelectedSupplierCommitment();
            this.resetSuppliersFilters({ filterId });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
@import '@style/base/_mixins.scss';

.filter-bar {
    :deep(.filter-bar__child-filter, .filter-bar__parent-filter) {
        input {
            min-width: 12rem !important;
        }
    }

    :deep(.filter-bar__parent-filter) {
        margin-right: 1rem;
    }

    &__cancel-button {
        margin-left: 1rem;
        margin-top: 0.2rem;
        padding-top: 0;
    }
}
</style>
